import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const SHORTCUT_OPTIONS = [
  "Hotel Policy",
  "Wi-Fi",
  "Special Services",
  "Hotel Amenities",
  "Activities",
  "FAQs",
];
const SERVICE_SHORTCUT_OPTION = "Special Services";

interface AddShortcutDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onAdd: (name: string) => void;
  showServiceShortcut?: boolean;
}

export const AddShortcutDialog: React.FC<AddShortcutDialogProps> = ({
  open,
  onOpenChange,
  onAdd,
  showServiceShortcut = true,
}) => {
  const { t } = useTranslation();
  const [name, setName] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (name) {
      onAdd(name);
      setName("");
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t("mobileSettings.dashboard.addShortcutTitle", {
              defaultValue: "Add Shortcut",
            })}
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>
              {t("mobileSettings.dashboard.shortcutName", {
                defaultValue: "Name",
              })}
            </Label>
            <Select value={name} onValueChange={setName}>
              <SelectTrigger className="w-full">
                <SelectValue
                  placeholder={t(
                    "mobileSettings.dashboard.shortcutPlaceholder",
                    {
                      defaultValue: "Select shortcut type",
                    },
                  )}
                />
              </SelectTrigger>
              <SelectContent>
                {SHORTCUT_OPTIONS.filter(
                  (option) =>
                    showServiceShortcut || option !== SERVICE_SHORTCUT_OPTION,
                ).map((option) => (
                  <SelectItem key={option} value={option}>
                    {option}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
            >
              {t("common.cancel")}
            </Button>
            <Button type="submit" className="bg-zinc-900 text-white">
              {t("mobileSettings.dashboard.addShortcutAction", {
                defaultValue: "Add Shortcut",
              })}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
